var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"align":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"#FF6465"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }